import React, { useState, useEffect } from "react";
import { XAxis, Line, Tooltip, LineChart, ResponsiveContainer } from "recharts";
import jMoment from "moment-jalaali";
import { Row, Col, Card } from "reactstrap";

import DatePicker from "../../components/Form/DatePicker";

import { getNewUserReportRequest } from "../../requests/analysisReports";

import { enDigits, faDigits, humanize } from "../../utils/formatDigits";


const NewUsersReports = props => {
  const [reportsData, setReportsData] = useState();
  const [loading, setLoading] = useState();
  const [dates, setDates] = useState({
    startDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD'),
    endDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD')
  });
  useEffect(() => {
    if (!reportsData && !loading) {
      getReport(dates.startDate, dates.endDate);
    }
  })
  const getReport = (startDate, endDate) => {
    setDates({
      startDate: faDigits(startDate),
      endDate: faDigits(endDate)
    });
    setLoading(true);
    getNewUserReportRequest({
      startDate,
      endDate
    })
      .then(response => {
        setReportsData(response.data);
        setLoading(false);
      })
  }
  if (!reportsData) return null;
  return (
    <Card body className="mt-3 mb-3" inverse color="dark">
      <Row>
        <Col>
          کاربران جدید
            <h2 className="h1">
            <strong dir="ltr">{humanize(reportsData.userVerified)}</strong>
          </h2>
        </Col>
        <Col dir="ltr" style={{
          position: 'absolute',
          width: '50%',
          height: 80,
          bottom: 0,
          right: 0
        }}>
          {reportsData.chartData && reportsData.chartData.length > 1 && (
            <ResponsiveContainer width="100%" aspect={4.0 / 1.0}>
              <LineChart
                width={400}
                height={100}
                data={reportsData.chartData.map(item => ({
                  ...item,
                  date: jMoment(item.date).format('jYYYY-jM-jD')
                }))}
              >
                <XAxis
                  dataKey="date"
                  padding={{ left: 30, right: 30 }}
                  style={{ display: 'none' }}
                />
                <Line
                  type="linear"
                  dataKey="count"
                  stroke="#afafaf"
                  strokeWidth={2}
                />
                <Tooltip />
              </LineChart>
            </ResponsiveContainer>
          )}
        </Col>
        <Col>
          <Row>
            <Col>
              از
              <DatePicker
                input={{
                  onChange: value => getReport(enDigits(value), dates.endDate),
                  value: dates.startDate
                }}
              />
            </Col>
            <Col>
              تا
              <DatePicker
                input={{
                  onChange: value => getReport(dates.startDate, enDigits(value)),
                  value: dates.endDate
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default NewUsersReports;